import React from 'react';
import ReactDOM from 'react-dom';
import './BroadcastBlockedIndicator.css';

/**
 * Визуальный индикатор блокировки интерфейса
 * Показывается поверх оверлея с иконкой замка
 * Рендерится через Portal в body для корректной работы backdrop-filter
 */
const BroadcastBlockedIndicator: React.FC = () => {
  // Рендерим через Portal напрямую в body
  return ReactDOM.createPortal(
    <div className="broadcast-blocked-indicator">
      <div className="blocked-icon">🔒</div>
      <div className="blocked-text">Интерфейс заблокирован</div>
      <div className="blocked-subtext">Подтвердите уведомление чтобы продолжить</div>
    </div>,
    document.body
  );
};

export default BroadcastBlockedIndicator;
